import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import { packBagSchema } from "../../Validation/Validation";
import CodeEditor from "../../Components/CodeEditor";

const AddPackBag = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    packBagName: editData?.packBagName,
    description: editData?.description || "",
    sortOrder: editData?.sortOrder || 1,
    min_qty: editData?.min_qty || 1,
    max_qty: editData?.max_qty || 1,
    isActive: editData?.isActive ?? false,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: packBagSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(
              `/packBag/updatePackBag/${editingId}`,
              values,
            )
          : await axiosInstance.post("/packBag/createPackBag", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/pack-bag");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Pack Bag", path: "/pack-bag" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Pack Bag
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="packBag-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="packBag-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="packBagName" className="col-form-label ">
                        Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="packBagName"
                        name="packBagName"
                        placeholder="Enter Pack Bag name"
                        value={values.packBagName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.packBagName && errors.packBagName && (
                        <small className="text-danger">
                          {errors.packBagName}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="packBag-minQty"
                        className="col-form-label "
                      >
                        Min Qty
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="packBag-minQty"
                        name="min_qty"
                        placeholder="Enter Min Qty"
                        min={0}
                        value={values.min_qty}
                        onChange={handleChange}
                      />
                      {touched.min_qty && errors.min_qty && (
                        <small className="text-danger">{errors.min_qty}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="packBag-maxQty"
                        className="col-form-label "
                      >
                        Max Qty
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="packBag-maxQty"
                        name="max_qty"
                        placeholder="Enter Max Qty"
                        min={1}
                        value={values.max_qty}
                        onChange={handleChange}
                      />
                      {touched.max_qty && errors.max_qty && (
                        <small className="text-danger">{errors.max_qty}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="packBag-description"
                        className="col-form-label "
                      >
                        Description
                      </label>
                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />
                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/pack-bag">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPackBag;
